import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from "@ispm/migration/components/login-component/component/login.component";
import {
  TranslationResolve,
  getCheckAuthLevel,
  getClinicalUsageLogin,
  getForgottenPasswordUrl,
  getVersion,
  oauth2LoginRedirect,
  redirectToDashboard,
  samlRedirect,
  smartRedirect,
  validateStateFromIAM
} from "@ispm/migration/components/login-component/login.route.resolve";
import {CurationContainerComponent} from './curation/components/curation-common/curation-container.component';
import {CurationDashboardComponent} from './curation/components/curation-dashboard/curation-dashboard.component';
import {
  resolveCurationDefinition,
  resolveCurationKbDefinition,
  resolveWorkflowConfigInit
} from './curation/curation-resolvable-exports';
import {DashboardHomeComponent} from './migration/components/home-component/home.component';
import {
  resolveClinicalParams,
  resolveWebConfigParams
} from './migration/components/home-component/home.route.resolve';
import {DashboardComponent} from "./worklist/components/dashboard/dashboard.component";
import {ProfileV2Component} from "@ispm/test/components/profileV2/profileV2.component";
import {TestViewComponent} from "@ispm/test/components/test-view/test-view.component";
import {
  resolveCustomConfigPathologist,
  resolveCustomConfigPathologistPatient,
  resolveCustomTotalTests,
  resolvePatient,
  resolvePatientParams,
  resolveTestConfig,
  resolveTests,
  resolveWorkflow,
  redirectToTestView,
  resolveTotalTests,
  resolveQcResults,
  resolvePrefetchData,
  resolvePollingUntilStep,
  resolveContextParam,
  resolveUserData,
  resolveIsPatientContext,
  redirectToPathologist,
  resolveTestTypesParams,
  resolveOrgsParams,
  resolveDiagnosticOrderUsingOrderId,
  resolveLayoutEngineParams,
  resolveClearCachedData,
  ExitGuard,
  resolveCurrentPatientIdentifier,
  resolvePatientLink,
  resolvePathHomeParams,
  prepareStore, changeWorkFlow, resetNotification
} from "@ispm/test/routes/test-view-routes-resolvable-exports";
import {TestInfoComponent} from "@ispm/test/components/test-info/test-info.component";
import {AberrationsComponent} from "@ispm/migration/components/aberrations/aberrations.component";
import {TherapyMatchComponent} from "@ispm/migration/components/therapyMatch/therapy-match.component";
import {CaseSummaryComponent} from "@ispm/test/components/case-summary/case-summary.component";
import {ReportPreviewComponent} from "@ispm/therapies/components/report-preview/report-preview.component";
import {TreatmentsComponent} from "@ispm/therapies/components/treatments/treatments.component";
import {ClinicalTrialsComponent} from "@ispm/migration/components/clinical-trial-migration/clinical-trial.component";
import {DataCollectionTabComponent} from "@ispm/test/components/data-collection-tab/data-collection-tab.component";
import {DocumentsTabComponent} from "@ispm/test/components/documents-tab/documents-tab.component";
import {
  resolveCurrentPatientIdentifierWorklist,
  resolveWorklistConfiguration,
  resolveWorklistTabConfiguration
} from "./worklist/worklist-resolvable-exports";
import {NewOrderComponent} from "@ispm/migration/components/new-order/new-order.component";
import {SpecimensAndSamplesComponent} from "./specimens-and-samples/components/specimens-and-samples/specimens-and-samples.component";
import {TechnicalInfoComponent} from "@ispm/test/components/technical-info/technical-info.component";
import {SignalResultsComponent} from "@ispm/test/components/signal-results/signal-results.component";
import {ProcessingComponent} from "@ispm/test/components/processing/processing.component";
import {AberrationsRouteWrapperComponent} from "@ispm/test/components/aberrations-route-wrapper/aberrations-route-wrapper.component";
import {QcResultsComponent} from "./quality-check/components/qc-results/qc-results.component";
import {TestSummaryComponent} from "@ispm/test/components/test-summary/test-summary.component";
import {PathwaysComponent} from '@ispm-client/modules/pathways';
import {DashboardTabComponent} from "./worklist/components/dashboard/dashboard-tabs/dashboard-tab.component";
import {LayoutEngineComponent} from "@ispm-client/modules/layout-engine/components/layout-engine/layout-engine.component";
import {IframeTestComponent} from "./iframe-test/iframe-test.component";
import {GenericErrorComponent} from "./worklist/components/generic-error/generic-error.component";
import {ExternalActionComponent} from "./external-action/simple-auth/external-action.component";
import {unauthorizedComponent} from "@ispm/migration/components/unauthorized/unauthorized.component";
import {DocumentsDownloadComponent} from "./documents-download/documents-download.component";
import {PathologistComponent} from "./migration/components/pathologist/pathologist";
import {goToPathologist} from "@ispm/migration/components/pathologist/pathologist.route.resolve";
import {ClinicalDashboardComponent} from "@ispm-client/modules/clinical-dashboard/components/clinical-dashboard/clinical-dashboard.component";
import {
  resolveClinicalDashboardForHome,
  resolveClinicalDashboardWithMrn
} from "@ispm-client/modules/clinical-dashboard/clinical-dashboard.route.resolve";
import {
  resolvePanCancerForReports,
  resolvePanCancerWithMrn,
  resolvePanCancerWithPatientId
} from "@ispm-client/modules/pan-cancer/pan-cancer.route.resolve";
import {OverlayLoaderComponent} from "@ispm/core/components/overlay-loader/overlay-loader.component";
import {PathHomeComponent} from "@ispm/migration/components/path-home/path-home.component";
import {
  SimilarPatientsAnalyticsViewComponent
} from "@ispm-client/modules/similar-patients/view/similar-patients-analytics-view.component";
import {patientResolver} from "@ispm-client/modules/similar-patients/similar-patients-exports";
import {
  SetWebEndpointValueInLocalStorage
} from "../ispm-admin/app/org-admin-settings/organizations/components/organization-form/org-admin-resolvables";


const routes: Routes = [
  {
    path: 'iframetest',
    component: IframeTestComponent
  },
  {
    path: 'generic-error',
    component: GenericErrorComponent,
    resolve: { translation: TranslationResolve }
  },
  {
    path: 'externalaction/:action',
    component: ExternalActionComponent
  },
  {
    path: 'unauthorized',
    component: unauthorizedComponent
  },
  {
    path: 'saml/login',
    resolve: {samlRedirect: samlRedirect},
    component: OverlayLoaderComponent
  },
  {
    path: 'oauth2/callback',
    resolve: {smartRedirect: oauth2LoginRedirect},
    component: OverlayLoaderComponent
  },
  {
    path: 'smart/launch',
    resolve: {smartRedirect: smartRedirect},
    component: OverlayLoaderComponent
  },
  {
    path: 'document',
    component: DocumentsDownloadComponent
  },
  {
    path: 'login', component: LoginComponent,
    resolve: {
      checkAuthLevel: getCheckAuthLevel,
      clinicalUsageLogin: getClinicalUsageLogin,
      version: getVersion,
      forgottenPasswordUrl: getForgottenPasswordUrl
    },
    data: {
      version: 'version',
      forgottenPasswordUrl: 'forgottenPasswordUrl'
    },
    canActivate: [redirectToDashboard]
  },
  {
    path: 'validateStateFromIAM',
    resolve: {validateStateFromIAM: validateStateFromIAM},
    component: OverlayLoaderComponent
  },
  {
    path: 'Pathologist',
    resolve: {
      goToPathologist: goToPathologist
    },
    component: PathologistComponent,
    children: [
      {
        path: '',
        component: PathHomeComponent,
        resolve: {
          resAnalyses: resolvePathHomeParams
        }
      }
    ]
  },
  {
    path: '', component: DashboardHomeComponent,
    resolve: {
      clinicalUsage: resolveClinicalParams,
      webConfig: resolveWebConfigParams,
      setWebEndpointValueInLocalStorage: SetWebEndpointValueInLocalStorage
    },
    children: [
      {
        path: 'dashboard/tabs/:type',
        component: DashboardTabComponent,
        resolve: {
          dashboardConfig: resolveWorklistTabConfiguration
        }
      },
      {
        path: 'dashboard/:type',
        component: DashboardComponent,
        runGuardsAndResolvers: "pathParamsChange",
        resolve: {
          dashboardConfig: resolveWorklistConfiguration
        },
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        runGuardsAndResolvers: "pathParamsChange",
        resolve: {
          dashboardConfig: resolveWorklistConfiguration
        },
      },
      {
        path: 'dashboard/:type/:patientId', component: DashboardComponent,
        resolve: {
          dashboardConfig: resolveWorklistConfiguration,
          currentPatientIdentifier: resolveCurrentPatientIdentifierWorklist
        },
      },
      {
        path: 'ClinicalDashboard',
        children: [
          {
            path: '',
            component: ClinicalDashboardComponent,
            resolve: {
              resolveFn: resolveClinicalDashboardWithMrn,
            }
          },
          {
            path: ':patientId',
            component: ClinicalDashboardComponent,
            resolve: {
              resolveFn: resolveClinicalDashboardForHome,
            },
          }
        ],
      },
      {
        path: 'Pancancer',
        children: [
          {
            path: '',
            component: LayoutEngineComponent,
            resolve: {
              layoutParams: resolvePanCancerWithMrn,
            }
          },
          {
            path: ':patientId/reports',
            component: LayoutEngineComponent,
            resolve: {
              layoutParams: resolvePanCancerForReports,
            }
          },
          {
            path: ':patientId',
            component: LayoutEngineComponent,
            resolve: {
              layoutParams: resolvePanCancerWithPatientId,
            }
          }
        ],
      },
      {
        path: 'Pathologist/order',
        component: NewOrderComponent,
        resolve: {
          patient: resolvePatientParams,
          orgs: resolveOrgsParams,
          testTypes: resolveTestTypesParams
        }
      },
      {
        path: 'Pathologist/order/:patientId',
        component: NewOrderComponent,
        resolve: {
          patient: resolvePatientParams,
          orgs: resolveOrgsParams,
          testTypes: resolveTestTypesParams
        }
      },
      {
        path: 'PatientAnalytics/:patientId',
        component: SimilarPatientsAnalyticsViewComponent,
        resolve: {
          patient: patientResolver
        }
      },
      {
        path: 'Pathologist/:patientId',
        component: ProfileV2Component,
        resolve: {
          patientParams: resolvePatientParams
        },
        children: [
          {
            path: ':testId/:revisionId',
            runGuardsAndResolvers: "pathParamsChange",
            component: TestViewComponent,
            data: {
              skipHistory: true
            },
            resolve: {
              workflowConfig: resolveWorkflow,
              isCustomConfig: resolveCustomConfigPathologist,
              contextParam: resolveContextParam,
              patient: resolvePatient,
              totalCustomTests: resolveCustomTotalTests,
              tests: resolveTests,
              testConfig: resolveTestConfig
            },
            canDeactivate: [ExitGuard],
            children: [
              {
                path: 'info',
                component: TestInfoComponent
              },
              {
                path: 'aberrations',
                component: AberrationsComponent
              },
              {
                path: 'prioritize',
                component: TreatmentsComponent
              },
              {
                path: 'case-summary',
                component: CaseSummaryComponent
              },
              {
                path: 'reportPreview',
                component: ReportPreviewComponent
              },
              {
                path: 'therapy',
                component: TherapyMatchComponent
              },
              {
                path: 'trials',
                component: ClinicalTrialsComponent
              },
              {
                path: 'documents-preview',
                component: DocumentsTabComponent
              },
              {
                path: 'collect-data',
                component: DataCollectionTabComponent
              },
              {
                path: 'specimens-and-samples',
                component: SpecimensAndSamplesComponent
              },
              {
                path: 'qc-results',
                component: QcResultsComponent
              },
            ],
          }
        ]
      },
      {
        path: 'Pathologist/PatientProfile/:patientId',
        component: ProfileV2Component,
        resolve: {
          clearCachedData: resolveClearCachedData
        },
        data: {
          skipRouteReusing: true
        },
        children: [
          {
            path: ':testId/:revisionId',
            runGuardsAndResolvers: "pathParamsChange",
            component: TestViewComponent,
            resolve: {
              workflow : resolveWorkflow,
              testConfiguration : prepareStore,
              isPatientContext: resolveIsPatientContext,
              contextParam: resolveContextParam,
              userdata: resolveUserData,
              isCustomConfig: resolveCustomConfigPathologistPatient,
              qcResults: resolveQcResults,
              prefetchData: resolvePrefetchData,
              pollingUntilStep: resolvePollingUntilStep,
              patientLink: resolvePatientLink,
              currentPatientIdentifier: resolveCurrentPatientIdentifier
            },
            canDeactivate: [
              resetNotification
            ],
            children: [
              {
                path: 'layoutEngine',
                component: LayoutEngineComponent,
                runGuardsAndResolvers: "paramsOrQueryParamsChange",
                resolve: {
                  layoutParams: resolveLayoutEngineParams
                }
              },
              {
                path: 'pathways',
                component: PathwaysComponent,
                data: {
                  skipHistory: true
                }
              },
              {
                path: 'documents-preview',
                component: DocumentsTabComponent,
                data: {
                  skipHistory: true
                }
              },
              {
                path: 'collect-data',
                component: DataCollectionTabComponent,
                data: {
                  skipHistory: true
                }
              },
              {
                path: 'therapy-prioritization',
                component: TreatmentsComponent,
                data: {
                  skipHistory: true
                }
              },
              {
                path: 'info',
                component: TestInfoComponent,
                data: {
                  skipHistory: true
                }
              }
            ]
          }
        ]
      },
      {
        path: 'Test/:orderId/:testId/:revisionId',
        component: TestViewComponent,
        resolve: {
          workflow: resolveWorkflow,
          diagnosticOrder: resolveDiagnosticOrderUsingOrderId,
          testConfiguration: prepareStore,
          qcResults: resolveQcResults
        },
        children: [
          {
            path: 'info',
            component: TestInfoComponent
          },
          {
            path: 'test-summary',
            component: TestSummaryComponent
          },
          {
            path: 'qc-results',
            component: QcResultsComponent
          },
          {
            path: 'aberrations',
            component: AberrationsRouteWrapperComponent
          },
          {
            path: 'signal-processing',
            component: ProcessingComponent
          },
          {
            path: 'signal-results',
            component: SignalResultsComponent
          },
          {
            path: 'signal-tech',
            component: TechnicalInfoComponent
          },
          {
            path: 'therapy-match',
            component: TherapyMatchComponent
          },
          {
            path: 'specimens-and-samples',
            component: SpecimensAndSamplesComponent
          },
        ]
      },
      {
        path: 'curation', component: CurationDashboardComponent,
        resolve:
          {
            CurationDefinition: resolveCurationDefinition
          },
      },
      {
        path: 'curation/:KB', component: CurationDashboardComponent,
        resolve: {
          CurationDefinition: resolveCurationKbDefinition
        }
      },
      {
        path: 'curation/:curationId/:workflowRequestId/:revisionId/:curationType',
        component: CurationContainerComponent,
        resolve: {
          CurationDefinition: resolveCurationDefinition,
          WorflowConfigInit: resolveWorkflowConfigInit
        }
      }
    ]
  }
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' , paramsInheritanceStrategy : 'always' })],
  exports: [RouterModule],
  providers: [getCheckAuthLevel, getClinicalUsageLogin, getVersion,
    getForgottenPasswordUrl, resolveClinicalParams, resolveWebConfigParams, resolveCurationDefinition,
    resolveWorkflowConfigInit, getForgottenPasswordUrl, resolveClinicalParams, resolveWebConfigParams,
    resolveTestConfig, resolveWorkflow, resolveCustomConfigPathologist, resolveCustomConfigPathologistPatient,
    resolvePatientParams, resolvePatient, resolveTests, resolveCustomTotalTests, redirectToTestView,
    resolvePollingUntilStep, resolvePrefetchData, resolveQcResults, resolveTotalTests,
    resolveContextParam, resolveUserData, resolveIsPatientContext, resolveLayoutEngineParams,
    redirectToPathologist, resolveOrgsParams, resolveTestTypesParams, resolveDiagnosticOrderUsingOrderId,
    resolveClearCachedData, ExitGuard, resolvePatientLink, resolveCurrentPatientIdentifier, resolvePathHomeParams
  ]

})
export class AppRoutingModule { }
